// Entry point del widget recensioni: la logica vive in toolReviewWidget.js, cosi' la
// promo card puo' riusarla senza che questo modulo sia insieme entry e dipendenza.
import { initToolReviews } from '/js/toolReviewWidget.js';

export { initToolReviews };

document.addEventListener('DOMContentLoaded', () => {
  initToolReviews();
});
